// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs-module__tabs--E_DHK","wrapper":"Tabs-module__wrapper--AhkyZ"};